import { Typography } from '@/components';
import { ConnectEmailMethod, TextStyles } from '@/constants';
import { useStatsigLayer } from '@/hooks';
import { ConnectGoogleButton } from '@/modules/pmt/components/ConnectGoogleButton';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { gtmClickEsyncCta, gtmConnectEmailSuccess, gtmViewEsyncCta } from '@/utils';
import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';
import {
  BannerTitle,
  ContentWrapper,
  EmailSyncBannerGraphic,
  EmailSyncWrapper,
  GmailStyleButton,
} from './LoggedInEsBanner.styles';

export const LoggedInESBanner = () => {
  const { notificationTranslation } = useMyParcelsContext();
  const { identifier, loggedInEsMainText, loggedInEsHasParcelsButtonText } = notificationTranslation;
  const { logEvent } = useStatsigClient();
  const { get, groupName } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const bannerDescription = get('ems_banner_description', loggedInEsMainText);
  const bannerCta = get('ems_banner_cta', loggedInEsHasParcelsButtonText);

  useEffect(() => {
    gtmViewEsyncCta({ variant: identifier });
  }, []);

  return (
    <EmailSyncWrapper>
      <EmailSyncBannerGraphic alt='Email sync banner device' src='/images/email-sync-banner-device.png' />
      <ContentWrapper>
        <BannerTitle>{bannerDescription}</BannerTitle>
        <ConnectGoogleButton
          buttonComponent={({ onClick }) => (
            <GmailStyleButton onClick={onClick}>
              <Typography variant={TextStyles['Button']}>{bannerCta}</Typography>
            </GmailStyleButton>
          )}
          handleClick={() => {
            gtmClickEsyncCta({ variant: identifier });
            logEvent('click_esync_cta', undefined, {
              ...(groupName !== null && { variant: groupName }),
            });
          }}
          onSuccess={() => {
            gtmConnectEmailSuccess(ConnectEmailMethod.EsyncCta);
            logEvent('connect_email_success');
          }}
        />
      </ContentWrapper>
    </EmailSyncWrapper>
  );
};
